module.exports = __webpack_public_path__ + "media/image3.c034bd04.mp4";